let urls;

export function loadOauthUrls(cb) {
    if (!urls) {
        $.ajax({
            url: window.location.protocol + '//' + window.location.host + '/oauth/ajax_auth_urls',
            data: {},
            type: 'get',
            dataType: 'json',
            success: function (data) {
                urls = data;
                cb(data);
            }
        });
    } else {
        cb(urls);
    }
}
